import LegalPage from "@/pages/legal/LegalPage";

export default function ChildSafetyPage() {
  return (
    <LegalPage
      title="Child Safety Standards"
      slug="child-safety"
      testIdPrefix="legal-child-safety"
    >
      <section>
        <h2>Our commitment</h2>
        <p>
          MyPandaX is an adults-only service for people aged 18 and older. We
          have zero tolerance for child sexual abuse or exploitation (CSAE),
          child sexual abuse material (CSAM), grooming, or any sexualized
          depiction of a minor. This content is prohibited in every area of
          MyPandaX, including profiles, posts, messages, groups, Live, and
          Vault.
        </p>
      </section>

      <section>
        <h2>Reporting and blocking</h2>
        <p>
          Members can report content or accounts in the app and can block
          accounts they do not want to interact with. Reports involving the
          safety of a child are prioritized and reviewed within 24 hours.
          Members can also contact our safety team at{' '}
          <a href="mailto:support@mypandax.com">support@mypandax.com</a>.
        </p>
      </section>

      <section>
        <h2>How we respond</h2>
        <p>
          We promptly review reports, remove content that violates these
          standards, and may suspend or permanently terminate accounts. We
          preserve and report suspected child sexual abuse material to the
          appropriate authorities and child-safety organizations when required
          by applicable law.
        </p>
      </section>

      <section>
        <h2>Related policies</h2>
        <p>
          These standards are supported by our{' '}
          <a href="/legal/acceptable-use-and-content-policy">
            Acceptable Use and Content Policy
          </a>{' '}
          and <a href="/legal/privacy-policy">Privacy Policy</a>.
        </p>
      </section>
    </LegalPage>
  );
}
